import { useId } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@shared/components';
import type { Product } from '@/features/products/types/products.types';
import type { QuoteServiceLineView } from '../../utils/quoteSummaryLines';
import { QuoteLinesTable } from './QuoteLinesTable';
import { ServiceItemLines } from './ServiceItemLines';

interface Props {
    product: Pick<Product, 'name' | 'description'>;
    lines: QuoteServiceLineView[];
    currency: string;
}

export function ServicesPanel({ product, lines, currency }: Props) {
    const headingId = useId();

    return (
        <Card>
            <CardHeader>
                <CardTitle>
                    <span id={headingId}>{product.name} - Services</span>
                </CardTitle>
            </CardHeader>
            <CardContent>
                <section aria-labelledby={headingId} className="space-y-6">
                    {product.description && (
                        <p className="text-sm text-mp-muted">{product.description}</p>
                    )}
                    <QuoteLinesTable<QuoteServiceLineView>
                        lines={lines}
                        emptyMessage="No services on this quote."
                        dateColumn={{ header: 'Due date', value: (line) => line.dueDate }}
                        renderNameCell={(line) => (
                            <>
                                <span>{line.name}</span>
                                <ServiceItemLines
                                    items={line.items}
                                    costMode={line.costMode}
                                    currency={currency}
                                    pricedLine={line.pricedLine}
                                />
                            </>
                        )}
                    />
                </section>
            </CardContent>
        </Card>
    );
}
